<template>
  <div id="app">    
    <app-drawer></app-drawer>
    <router-view />
  </div>
</template>
<script>
import Vue from 'vue';
import { Message, Modal,locale  } from 'view-design'
import { mapActions, mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
import AppDrawer from '@/components/AppDrawer.vue';
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN'; 
import ko from 'view-design/dist/locale/ko-KR';
import fr from 'view-design/dist/locale/fr-FR';

const lang = localStorage.getItem('system.lang') || 'zh-cn';
switch (lang) {
  case 'zh-cn':
    locale(zh);
    break;
  case 'en-us':
    locale(en);
    break;
  case 'ko-kr':
    locale(ko);
    break;
  case 'fr-fr':
    locale(fr);
    break;  
  default:
    locale(zh);
    break;
}

Vue.prototype.$Message = Message
Vue.prototype.$Modal = Modal
Vue.prototype.$Message.config({
  duration: 3
})
Vue.config.errorHandler = function (err, vm, info) {
  postJsError(err, vm, info)
}
export default {
  name: 'AppHeron', // 组件名称
  components: {    
    AppDrawer,
  },
  computed: {
    ...mapGetters(['getLang', 'getTranslation'])
  },
  created() {
    this.initApp()
  },
  data() {
    return {
    }
    
  },
  methods: {
    ...mapActions(['fetchLang']),
    async initApp() {
      // 设置全局语言变量，保持兼容性
      Vue.prototype.$lang = this.$store.state.lang

      try {
        // 从服务器获取语言数据
        const langData = await this.fetchLang()
        Vue.prototype.$lang = langData
      } catch (error) {
        console.error('Failed to initialize language:', error)
      }
    }
    
  }

}
</script>
